<ng-container>
  <div class="add-employee-wrapper">
    <p>{{ 'myAccount.userDetails' | cxTranslate }}</p>
    <div class="left-section">
      <app-dynamic-form
        (formGroupEmit)="updateFormGroup($event)"
        (formModelEmit)="updateFormModel($event)"
        [emitOnInit]="true"
        [formGroupId]="'ADD_EMPLOYEE'"
        [static]="false"
        [activeLanguage]="activeLanguage$ | async"
        [ngClass]="activeLanguage$ | async"
      ></app-dynamic-form>
    </div>
  </div>
  @if (accountPermissionsEnabled) {
  <app-myaccount-employee-address
    (activeAddresses)="activeAddresses($event)"
    (addressHasChanged)="hasChanged($event)"
    (isAddressSelected)="hasAddressSelected($event)"
  >
  </app-myaccount-employee-address>
  <app-myaccount-permissions (activePermission)="activePermission($event)" (permissionsChanged)="hasChanged($event)">
  </app-myaccount-permissions>
  }
  <div class="add-button-wrapper">
    <div class="cancel-btn-wrapper">
      <a href="#">{{ 'common.cancel' | cxTranslate }}</a>
    </div>
    <div class="main-btn-wrapper">
      <button
        mat-button
        [disabled]="!this.formGroup?.valid || !isAddressSelected || buttonNoUpdate"
        class="btn secondary-btn"
        [ngClass]="activeLanguage$ | async"
        (click)="onSubmit($event, 'create')"
      >
        {{ 'myAccount.saveAndCreateNew' | cxTranslate }}
      </button>
      <button
        mat-button
        [disabled]="buttonNoUpdate || !this.formGroup?.valid || !isAddressSelected"
        class="btn primary-btn"
        [ngClass]="activeLanguage$ | async"
        (click)="onSubmit($event, 'close')"
      >
        {{ 'myAccount.saveAndClose' | cxTranslate }}
      </button>
    </div>
  </div>
</ng-container>
